function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Sticky
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/sticky.scss";
import CBUtils from "./CBUtils";

/**
 * Sticky Container
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Number} data.offsetTop
 * @param {Boolean} data.dropShadow
 * @param {Boolean} data.parent
 * @param {Element} data.localNavElem
 * @param {Function} data.callBack
 * @returns {{destroy: Function}}
 */
var Sticky = function Sticky() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    offsetTop: 0,
    dropShadow: true,
    parent: false,
    localNavElem: null,
    callBack: null
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  var localNavElem = data.localNavElem;
  var callBack = data.callBack;
  var parentElem = null;
  var scrollHappened = false;
  var offsetTop = data.offsetTop;
  var offset = 0;
  var height = 0;
  // for delayed resize
  var resizeId = 0;
  if (!CBUtils.elemExists(elem)) return null;
  var init = function init() {
    elem.sticky = "cb";
    if (data.parent) {
      parentElem = CBUtils.parent(elem);
    } else {
      parentElem = window;
    }

    // stick container and push up local Navigation
    if (CBUtils.elemExists(localNavElem)) {
      window.addEventListener("resize", delayedResize);
      parentElem.addEventListener("scroll", stickAndPushFunction);
    } else {
      parentElem.addEventListener("scroll", stickFunction);
    }
  };
  var delayedResize = function delayedResize() {
    clearTimeout(resizeId);
    resizeId = setTimeout(adjustHeightVariables, 500);
  };
  var adjustHeightVariables = function adjustHeightVariables() {
    scrollHappened = false;
    stickAndPushFunction();
  };
  var stickAndPushFunction = function stickAndPushFunction() {
    var bPos = 0;
    var docScroll = data.parent ? parentElem.scrollTop : document.body.scrollTop || document.documentElement.scrollTop;
    if (!scrollHappened) {
      // offsetTop = CBUtils.offset(elem) ? CBUtils.offset(elem).top : 0;
      height = CBUtils.outerHeight(localNavElem);
      if (data.parent) {
        offset = CBUtils.offsetToParent(elem) ? CBUtils.offsetToParent(elem).top : 0;
      } else {
        offset = CBUtils.offset(elem) ? CBUtils.offset(elem).top : 0;
      }
      scrollHappened = true;
    }
    if (docScroll >= offset - height) {
      bPos = offset - docScroll;
      if (bPos < 0) {
        if (!CBUtils.hasClass(elem, "cb-sticky-active")) {
          CBUtils.addClass(elem, "cb-sticky-active");
          data.dropShadow && CBUtils.addClass(elem, "cb-box-shadow-bottom");
          elem.style.top = "0";
          localNavElem.style.top = "-".concat(height + 8, "px");
          callBack && callBack(true);
        }
      } else {
        bPos = offset - docScroll;
        localNavElem.style.top = "".concat(bPos - height, "px");
      }
    } else {
      if (CBUtils.hasClass(elem, "cb-sticky-active")) {
        CBUtils.removeClass(elem, "cb-sticky-active");
        data.dropShadow && CBUtils.removeClass(elem, "cb-box-shadow-bottom");
        localNavElem.style.top = "0";
        callBack && callBack(false);
      }
    }
  };
  var stickFunction = function stickFunction() {
    var docScroll = parent ? parentElem.scrollTop : document.body.scrollTop || document.documentElement.scrollTop;
    if (!scrollHappened) {
      if (parent) {
        offset = CBUtils.offsetToParent(elem) ? CBUtils.offsetToParent(elem).top : 0;
      } else {
        offset = CBUtils.offset(elem) ? CBUtils.offset(elem).top : 0;
      }
      scrollHappened = true;
    }
    if (docScroll > offset - offsetTop) {
      if (!CBUtils.hasClass(elem, "cb-sticky-active")) {
        CBUtils.addClass(elem, "cb-sticky-active");
        data.dropShadow && CBUtils.addClass(elem, "cb-box-shadow-bottom");
        elem.style.top = "".concat(offsetTop, "px");
        callBack && callBack(true);
      }
    } else {
      if (CBUtils.hasClass(elem, "cb-sticky-active")) {
        elem.style.top = null;
        CBUtils.removeClass(elem, "cb-sticky-active");
        data.dropShadow && CBUtils.removeClass(elem, "cb-box-shadow-bottom");
        callBack && callBack(false);
      }
    }
  };
  var destroy = function destroy() {
    if (elem.sticky === "cb") {
      elem.sticky = null;
      if (CBUtils.elemExists(localNavElem)) {
        document.removeEventListener("apricot_breakpointChange", adjustHeightVariables);
        parentElem.removeEventListener("scroll", stickAndPushFunction);
      } else {
        parentElem.removeEventListener("scroll", stickFunction);
      }
    }
  };
  if (elem.sticky !== "cb") {
    init();
  }
  return {
    destroy: destroy
  };
};
export default Sticky;